import { BehaviorSubject } from 'rxjs';
import { TLoader } from './loader.type';

export default class LoaderService {
  initial: TLoader = { loading: false };
  private _state: BehaviorSubject<TLoader> = new BehaviorSubject(this.initial);
  get state$() {
    return this._state.asObservable();
  }

  show() {
    return this._state.next({ loading: true });
  }

  hide() {
    return this._state.next({ loading: false });
  }
}
